import {
  EnvironmentConfig,
  ADConfig
} from './environment.models';

import { serviceRoutesContainer } from '../serviceroutes/serviceroutes'

var webUIResourceId: string = "6fba1cbd-c2e3-449e-8d23-05997e5ef755"

export const environment: EnvironmentConfig = {
  environmentName: 'test',
  production: true, 
  hmr: false,
  config: {
      tenant: 'VillaPlusLtd.onmicrosoft.com',
      clientId: webUIResourceId,
      protectedResourceMap: createEndpointsConfig(),
      redirectUri: serviceRoutesContainer.test.projectWebBaseUrl,
      postLogoutRedirectUri: serviceRoutesContainer.test.projectWebBaseUrl,
      isAngular: true
  } as ADConfig,
  configIFrame: {
      tenant: 'VillaPlusLtd.onmicrosoft.com',
      clientId: webUIResourceId,
      protectedResourceMap: createEndpointsConfig(),
      redirectUri: serviceRoutesContainer.test.projectWebBaseUrl,
      isAngular: true
  } as ADConfig,
  services: serviceRoutesContainer.test,
} as EnvironmentConfig;

function createEndpointsConfig(): Map<string, Array<string>> {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(serviceRoutesContainer.test.microsoftGraphBaseUrl, ['user.read']);
  protectedResourceMap.set(serviceRoutesContainer.test.projectWebBaseUrl, [webUIResourceId + '/user_impersonation']);
  return protectedResourceMap;
}

